import $ from 'jquery';
import { mapGetters } from 'vuex';
import { densityBarRefreshEventHub } from 'library-@/components/DensityBar';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { QueryHighlightService } from '@/domains/highlight/services/query-highlight-service';
import { CustomHighlightService } from '@/domains/highlight/services/custom-highlight-service';
import { ChemicalEntryService } from '@/components/chemical/service/chemical-entry.service';

export default {
    data() {
        return {
            isEnableKeywordHighlight: false,
            backendKeywords: [],
            enable: false,
        };
    },
    computed: {
        ...mapGetters({
            bioHighlightEnable: 'bio/highlightEnable',
        }),
    },
    methods: {
        refreshDensityBar() {
            densityBarRefreshEventHub.emit('update');
        },
        initDensityBar() {
            this.refreshDensityBar();
        },
        emptyDensityData() {
            this.refreshDensityBar();
        },
    },
    watch: {
        isEnableKeywordHighlight() {
            this.initDensityBar();
        },
        bioHighlightEnable() {
            this.initDensityBar();
        },
        enable() {
            this.initDensityBar();
        },
        backendKeywords: {
            handler() {
                this.initDensityBar();
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        const queryHighlightService = injectService(QueryHighlightService);
        this.backendKeywords = queryHighlightService.getModelData();
        this.disposeQueryHighlightService = queryHighlightService.onStatesChange(state => {
            this.backendKeywords = state;
        });

        const customHighlightService = injectService(CustomHighlightService);
        this.isEnableKeywordHighlight = customHighlightService.getModelData().isEnable;
        this.disposeCustomHighlightService = customHighlightService.onStatesChange(state => {
            this.isEnableKeywordHighlight = state.isEnable;
        });

        const chemicalEntryService = injectService(ChemicalEntryService);
        this.enable = chemicalEntryService.state.highlightEnabled;
        this.disposeChemicalEntryService = chemicalEntryService.onStatesChange(state => {
            this.enable = state.highlightEnabled;
        });
    },
    mounted() {
        $(window)
            .off('resize', this.initDensityBar)
            .on('resize', this.initDensityBar);
    },
    beforeDestroy() {
        $(window).off('resize', this.initDensityBar);
        this.emptyDensityData();
        this.disposeQueryHighlightService?.dispose();
        this.disposeCustomHighlightService?.dispose();
        this.disposeChemicalEntryService?.dispose();
    },
};
